import { render, staticRenderFns } from "./AboutMemberList.vue?vue&type=template&id=107a5971&"
import script from "./AboutMemberList.vue?vue&type=script&lang=js&"
export * from "./AboutMemberList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports